import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorChromeModule } from 'ngx-color/chrome';
import { ColorBlockModule } from 'ngx-color/block';
import { ColorGithubModule } from 'ngx-color/github';
import { ColorTwitterModule } from 'ngx-color/twitter';
import { ColorHueModule } from 'ngx-color/hue';
import { ColorAlphaModule } from 'ngx-color/alpha';
import { ColorCircleModule } from 'ngx-color/circle';
import { ColorSliderModule } from 'ngx-color/slider';
import { ColorMaterialModule } from 'ngx-color/material';
import { ColorShadeModule } from 'ngx-color/shade';
import { ColorSwatchesModule } from 'ngx-color/swatches';


const modules = [
  ColorChromeModule,
  ColorBlockModule,
  ColorGithubModule,
  ColorTwitterModule,
  ColorHueModule,
  ColorAlphaModule,
  ColorCircleModule,
  ColorSliderModule,
  ColorMaterialModule,
  ColorShadeModule,
  ColorSwatchesModule,
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ...modules
  ],
  exports: [...modules]
})
export class ColorsModule { }
